/**
 * Created by jv on 10/02/2017.
 */
const utils = require("Sources/utils/utils");
const Catalog = require("Sources/models/store/catalog");
const Cart = require("Sources/models/store/cart");
const OrderInfo = require("Sources/models/store/order-info");

module.exports = class SessionData
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.catalog = options.catalog;
    this.cart = options["shopping-cart"];
    this.orderInfo = options["order-info"];
  };

  set catalog(catalog)
  {
    this._catalog = new Catalog(catalog);
  }

  get catalog()
  {
    return this._catalog;
  }

  set cart(cart)
  {
    this._cart = new Cart(cart);
  }

  get cart()
  {
    return this._cart;
  }

  set orderInfo(orderInfo)
  {
    this._orderInfo = new OrderInfo(orderInfo);
  }

  get orderInfo()
  {
    return this._orderInfo;
  }
};



// WEBPACK FOOTER //
// ./app/js/models/store/session-data.js